export default __webpack_public_path__ + "static/media/el_acorde.8d8c5694.png";